import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';

declare let $: any;

@Component({
  selector: 'app-tanker-water-requests',
  templateUrl: './tanker-water-requests.component.html',
  styleUrls: ['./tanker-water-requests.component.css']
})

export class TankerWaterRequestsComponent implements OnInit {
  lst_WaterRequests: any = [];
  lst_Search = [];
  tankerList: any = [];
  selectedItems: any = [];

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

  });

  approveForm: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iTanker_DeliverySchedule: ['', Validators.required],

    strDelivery_Date: ['', Validators.required],

    strDelivery_Time: ['', Validators.required],

    iValue: ['', [Validators.required, Validators.min(1)]],

    strComment: [''],

    strUnitID: ['']

  });

  rejectForm: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iTanker_DeliverySchedule: ['', Validators.required],

    strComment: ['', Validators.required]

  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
  ) {

  }

  ngOnInit(): void {
    this.getWaterRequests();
    this.getTanker();
  }

  ngAfterViewInit() {
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
  }

  getWaterRequests = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_WaterRequests_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_WaterRequests = res;
    this.lst_Search = res;

  }

  filterResult(strValue: string) {

    if (strValue.length > 1) {

      this.lst_WaterRequests = this.lst_Search.filter((el: any) => {

        return (el.strClientName ?? '').includes(strValue) ||
          (el.strComment ?? '').includes(strValue) ||
          (el.strFullName ?? '').includes(strValue) ||
          (el.strScheduleStatus ?? '').includes(strValue)

      })

    }

    else if (strValue == '') this.lst_WaterRequests = this.lst_Search

  }

  getTanker = async () => {

    this._other.Showspinner();

    const model = this._other.stringNumberToNumber(this.mdl_Search.value);

    let res = JSON.parse((await axios.post('Tanker_List', model)).data.toString());

    if (res.ISSessionExpired == true) {

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: '14' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this._other.nonespinner();

    this.tankerList = res;

  }

  setCheckBox(value: boolean, item: any) {
    if (value === true) {
      if (!this.selectedItems.includes(item.iTanker_DeliverySchedule)) {
        this.selectedItems.push(item.iTanker_DeliverySchedule);
      }
    }

    else {
      const index = this.selectedItems.indexOf(item.iTanker_DeliverySchedule);
      if (index !== -1) this.selectedItems.splice(index, 1);
    }
  }

  openApproveModal(item: any) {

    let deliveryDate = '';
    let deliveryTime = '';

    if (item.strRequestedDeliveryTime) {
      const parts = item.strRequestedDeliveryTime.split(' ');
      deliveryDate = parts[0] ?? '';
      const timePart = parts[1] ?? '';
      deliveryTime = timePart.length >= 5 ? timePart.substring(0, 5) : timePart;
    }

    this.approveForm.patchValue({

      iTanker_DeliverySchedule: item.iTanker_DeliverySchedule,

      strDelivery_Date: deliveryDate,

      strDelivery_Time: deliveryTime,

      iValue: item.iValue ?? '',

      strComment: item.strComment ?? '',

      strUnitID: item.strUnitID ?? ''

    });

    $("#approveDeliveryTime").val(deliveryTime)

    this._other.markAllAsUnTouched(this.approveForm);

    $("#approveWaterRequestModal").modal("show");

  }

  openRejectModal(item: any) {

    this.rejectForm.patchValue({

      iTanker_DeliverySchedule: item.iTanker_DeliverySchedule,

      strComment: ''

    });

    this._other.markAllAsUnTouched(this.rejectForm);

    $("#rejectWaterRequestModal").modal("show");

  }

  submitApprove = async () => {

    this.approveForm.get('strDelivery_Time')?.setValue($("#approveDeliveryTime").val());

    if (this.approveForm.invalid) {
      this._other.markAllAsTouched(this.approveForm);
      this._tooltip.showError('لطفا موارد ضروری را با دقت تکمیل کنید');
      return;
    }

    const model = this._other.stringNumberToNumber(this.approveForm.value);

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_DeliverySchedule_ApproveWaterRequest`, model)).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this._tooltip.showSuccess('با موفقیت تایید شد');

    $("#approveWaterRequestModal").modal('hide');

    this.getWaterRequests();

  }

  submitReject = async () => {

    if (this.rejectForm.invalid) {
      this._other.markAllAsTouched(this.rejectForm);
      this._tooltip.showError('لطفا توضیحات را وارد کنید');
      return;
    }

    const model = this._other.stringNumberToNumber(this.rejectForm.value);

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_DeliverySchedule_RejectWaterRequest`, model)).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this._tooltip.showSuccess('با موفقیت رد شد');

    $("#rejectWaterRequestModal").modal('hide');

    this.getWaterRequests();

  }

}
